import React from 'react';
import moment from 'moment';

import "./social-user-card.scss";

const UserCard = (props:any) => {
  
  const noFoto =  require("../../../../static/commenter-nofoto.png").default;
  const aDate = props.date ? props.date : moment(Date.now()).format('DD/MM/YYYY');

  return (
      <>
        <div className="user-data">
          <div className="user-data-pic">
            <img src={props.userpic ? props.userpic : noFoto} />
          </div>
          <div className="user-data-other">
              <div className="user-data-name">
                {props.username}
              </div>
              <div className="user-data-cmt-date">
                {aDate}
              </div>
          </div>
        </div>
      </>
  );

}

export default UserCard;
